exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.footer {\n  border: none;\n  background-color: #777;\n  font-size: 14px;\n  margin: 0;\n  flex: 0;\n}\n@media print {\n  div.footer {\n    display: none;\n  }\n}\ndiv.footer-copyright {\n  color: #fff;\n  margin-top: 10px;\n  text-align: left;\n  padding-left: 10px;\n  margin-bottom: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/Footer.styl
// module id = 1896
// module chunks = 1